//@ flow
import { takeLatest, select, put } from "redux-saga/effects";
import { getMedidasFixas, adicionarMedidas } from "../state";

export default function* limparSelecaoSaga({ frameApi }) {
  yield takeLatest("LIMPAR_SELECAO", function*(): any {
    const SUBSTITUIR_SELECAO = true;

    const medidasIniciais: Array<MedidaSelecionada> = yield select(
      getMedidasFixas
    );

    yield put(adicionarMedidas(medidasIniciais, SUBSTITUIR_SELECAO));

    yield frameApi.salvarArquivoMedidas(null);
  });
}
